var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPost3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C8.68626 1 6 3.68633 6 6.99995C6 10.3137 8.68626 13 12 13C15.3137 13 18 10.3137 18 6.99995C18 3.68633 15.3137 1 12 1Z",
    fill: "#BD63F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0074 16.4301C15.75 13.19 8.24978 13.19 1.99255 16.4301C1.38176 16.7464 1 17.3654 1 18.0393V22.0761C1 23.1387 1.88395 24 2.97441 24H21.0255C22.116 24 23 23.1387 23 22.0761V18.0393C23 17.3654 22.618 16.7464 22.0074 16.4301Z",
    fill: "#BD63F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94447 1.66669C1.79104 1.66669 1.66669 1.79106 1.66669 1.94447V4.16672C1.66669 4.62688 1.29358 5 0.833343 5C0.373104 5 0 4.62688 0 4.16672V1.94447C0 0.870566 0.870566 0 1.94447 0H4.16672C4.62688 0 5 0.373104 5 0.833343C5 1.29358 4.62688 1.66669 4.16672 1.66669H1.94447Z",
    fill: "#D9A5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94447 11.3333C1.79104 11.3333 1.66669 11.2089 1.66669 11.0556V8.83328C1.66669 8.37312 1.29358 8 0.833343 8C0.373104 8 0 8.37312 0 8.83328V11.0556C0 12.1294 0.870566 13 1.94447 13H4.16672C4.62688 13 5 12.6269 5 12.1667C5 11.7064 4.62688 11.3333 4.16672 11.3333H1.94447Z",
    fill: "#D9A5FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0556 11.3333C22.2089 11.3333 22.3333 11.2089 22.3333 11.0556V8.83328C22.3333 8.37312 22.7064 8 23.1667 8C23.6269 8 24 8.37312 24 8.83328V11.0556C24 12.1294 23.1294 13 22.0556 13H19.8333C19.3731 13 19 12.6269 19 12.1667C19 11.7064 19.3731 11.3333 19.8333 11.3333H22.0556Z",
    fill: "#D9A5FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0556 1.66669C22.2089 1.66669 22.3333 1.79106 22.3333 1.94447V4.16672C22.3333 4.62688 22.7064 5 23.1667 5C23.6269 5 24 4.62688 24 4.16672V1.94447C24 0.870566 23.1294 0 22.0556 0H19.8333C19.3731 0 19 0.373104 19 0.833343C19 1.29358 19.3731 1.66669 19.8333 1.66669H22.0556Z",
    fill: "#D9A5FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPost3);
export default __webpack_public_path__ + "static/media/job-post3.3585edde2301aca2f70a0245138a1cf9.svg";
export { ForwardRef as ReactComponent };